/************************************************************
 * Project: Book App
 * Author: Marcos Santos - A01072792
 * BCIT class Comp2913 - ReactJS by Daniel Takeuchi
 * Date: October, 10, 2020.
 * Description: Assignment - Book App
 * https://github.com/maasantos10/
 ************************************************************/

import React from 'react';
import { Container } from './styles';

import './style.css';

interface PaginationProps {
  
  isVisible: boolean;
  content: string;
  currentPage: number;
  totalPage: number;
  totalRecords: number;
  
}

const Pagination: React.FC<PaginationProps> = ({  
  isVisible,
  content,
  currentPage,
  totalPage,
  totalRecords,
  children,
}) => {
  return (
    <Container >
      {children}
      {isVisible && (
      <div className='books'>
          <div >
      <div>Page: {currentPage} of {totalPage} / total records: {totalRecords}</div> 
          </div>
      </div>
      )}
    </Container>
  );
};

export default Pagination;
